import Luxe1 from '../../../Media/BSD/Terravia/Terravia Adora Luxe.webp'
import Luxe2 from '../../../Media/BSD/Terravia/Terravia Adora Luxe.webp'





const Luxeimages =[
Luxe1,Luxe2
]

export default Luxeimages;